import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";

import { withStyles } from "@material-ui/core/styles";
import withWidth from "@material-ui/core/withWidth";
import Grid from "@material-ui/core/Grid";
import AppBar from "@material-ui/core/AppBar";
import Typography from "@material-ui/core/Typography";
import Toolbar from "@material-ui/core/Toolbar";
import Divider from "@material-ui/core/Divider";
import IconButton from "@material-ui/core/IconButton";
import MenuIcon from "@material-ui/icons/Menu";

const styles = (theme) => ({
  appBarSpacer: theme.mixins.toolbar,
  appBarTitle: {
    flexGrow: 1,
  },
  circle: {
    display: "inline-block",
    height: "10px",
    width: "10px",
    borderRadius: "5px",
    marginRight: "10px",
  },
});

function StudentTopBar(props) {
  let title = props.currentCourseName || "WebClicker";

  return (
    <AppBar color="inherit" position="fixed" elevation={0}>
      <Toolbar>
        <Grid
          container
          direction="row"
          justifyContent="space-between"
          alignItems="center"
        >
          <Grid item>
            <Grid container direction="row" alignItems="center">
              <Grid item>
                <IconButton
                  color="inherit"
                  onClick={() => {
                    props.userMenuOpenCtl(!props.userMenuOpen);
                  }}
                >
                  <MenuIcon />
                </IconButton>
              </Grid>

              <Grid>
                <Typography className={props.classes.appBarTitle} variant="h6">
                  {title}
                </Typography>
              </Grid>
            </Grid>
          </Grid>

          <Grid item>
            <Grid container direction="row" alignItems="center">
              {props.currentCourseName ? (
                <>
                  <div
                    className={props.classes.circle}
                    style={{
                      backgroundColor: props.pollLive ? "green" : "red",
                    }}
                  />
                  <Typography
                    style={{
                      paddingRight:
                        window.innerWidth < 285 && props.pollLive
                          ? "20px"
                          : "0px",
                    }}
                  >
                    {props.pollLive ? "Poll is live" : "No current poll"}
                  </Typography>
                </>
              ) : null}
            </Grid>
          </Grid>
        </Grid>
      </Toolbar>

      <Divider />
    </AppBar>
  );
}

const mapStateToProps = (state) => {
  return {};
};

const mapDispatchToProps = (dispatch) => {
  return {};
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(
  withRouter(
    withStyles(styles, { withTheme: true })(withWidth()(StudentTopBar))
  )
);
